export const defaultIconVariant = "inverse";
export const defaultThemeVariant = "light";

export const iconVariantsConfig = {
	light: {
		base: {
			default: {
				default: "primary",
				open: "primary",
				scroll: "primary",
			},
			navGradient: {
				default: "inverse",
				open: "primary",
			},
			navGradientSticky: {
				default: "inverse",
				scroll: "primary",
				open: "primary",
			},
			navFloat: {
				default: "primary",
				open: "primary",
				scroll: "primary",
			},
		},
	},
	dark: {
		base: {
			default: {
				default: "inverse",
				open: "inverse",
				scroll: "inverse",
			},
		},
	},
};

export const txpMotionClasses = {
	motionFadeIn: "motion-fade-in",
	motionFadeOut: "motion-fade-out",
	motionPositionNavEnterDown: "motion-position-nav-enter-down",
	motionPositionShiftExitLeft: "motion-position-shift-exit-left",
	motionPositionShiftSoarLeft: "motion-position-shift-soar-left",
	motionPositionNavBackRight: "motion-position-nav-back-right",
	motionPositionNavEnterLeft: "motion-position-nav-enter-left",
	motionPositionEnterGentleDown: "motion-position-enter-gentle-down",
};

export const txpMotionDelayMs = {
	betweenAnimations: 33,
	none: 0,
	micro: 50,
	tiny: 100,
	compactDefault: 50,
	compactNoImage: 150,
	big: 200,
	fadeOutDuration: 100,
};

export const searchOpenLinkId = "_Header_Search_Open";

export const profileSectionIds = ["myPlans", "myDVC"];

export const isProfileSection = (id) => profileSectionIds.includes(id);

const defaultAvatars = {
	dvc: "/images/avatar/dvc/default-avatar.svg",
};

/**
 * Resolves the avatar image source with a fallback chain:
 * 1. User's uploaded avatar
 * 2. CMS default avatar from the profile section (myPlans/myDVC primary image)
 * 3. Brand-specific static avatar from CDN
 * 4. Empty string
 */
export const getAvatarSrc = ({ user, defaultAvatar, brand, getCdn }) => {
	return (
		user?.avatar?.url ||
		defaultAvatar ||
		(defaultAvatars?.[brand]
			? `${getCdn(true)}${defaultAvatars[brand]}`
			: "") ||
		""
	);
};
